import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelEquiposView from './PanelEquiposView';
import * as ROUTES from '../../../../router/Routes';

const PanelEquiposModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelEquipos}
      routes={[ROUTES.juegosDeportivos, ROUTES.equipos]}
    >
      <PanelEquiposView />
    </ContainerTemplate>
  );
};

export default PanelEquiposModule;
